import * as React from 'react';

const StarFilled24 = ({ title, titleId, ...props }) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", width: 24, height: 24, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("g", { fill: "none", fillRule: "evenodd" }, /* @__PURE__ */ React.createElement("path", { d: "M0 0h24v24H0z" }), /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M2.366 8.667h6.717l2.047-6.036A.922.922 0 0 1 12 2a.92.92 0 0 1 .87.631l2.047 6.036h6.717c.478 0 .866.394.866.879a.884.884 0 0 1-.364.717l-5.365 3.873 2.318 6.838A.772.772 0 0 1 18.37 22a.746.746 0 0 1-.442-.143L12 17.58l-5.926 4.277a.75.75 0 0 1-.443.143.772.772 0 0 1-.72-1.026l2.318-6.838-5.365-3.873a.884.884 0 0 1-.364-.717c0-.485.388-.879.866-.879"
  }
)));
StarFilled24.Size = 24;
StarFilled24.Title = "StarFilled";

export { StarFilled24 as default };
